export const LOCALSTORAGE_KEYS = {
    privateToken: 'privateToken',
};
